import { useEffect, useMemo } from 'react';

import {
    useIsCategoryLoading
} from 'js/app/components/main/Games/components/GameCategory/components/GameList/hooks/useIsCategoryLoading';
import { DYNAMIC_CATEGORIES } from 'js/app/components/main/Games/constants';
import { useFilterDynamicCategory } from 'js/app/components/main/Games/hooks/useFilterDynamicCategory';
import { setFeedAction } from 'js/app/components/main/Games/store/actions';
import { useGamesDispatch, useGamesSelector } from 'js/app/components/main/Games/store/context';

export const useCheckEmptyFeed = () => {
    const dispatch = useGamesDispatch();
    const { categories } = useGamesSelector();
    const filterCategories = useFilterDynamicCategory();
    const checkIsCategoryLoading = useIsCategoryLoading();
    const isLoading = useMemo(() => {
        return categories.some(checkIsCategoryLoading);
    }, [categories, checkIsCategoryLoading]);
    const filteredCategories = useMemo(() => {
        return categories
            .filter(category => category.name !== DYNAMIC_CATEGORIES.ALL_CATEGORY && filterCategories(category));
    }, [categories, filterCategories]);

    useEffect(() => {
        if (!isLoading) {
            return;
        }

        if (!filteredCategories.length) {
            dispatch(setFeedAction({
                feed: {
                    name: '',
                    categories: []
                },
                isEmptyFeed: true,
                dynamicCategories: [],
                categories: [],
                activeCategory: {}
            }));
        }
    }, [dispatch, filteredCategories, isLoading]);
};
